export interface NewsPost {
  slug: string;
  titleKey: string;
  excerptKey: string;
  date: string;
  readingTimeKey: string;
}

export const NEWS_POSTS: NewsPost[] = [
  {
    slug: "closed-alpha-launch",
    titleKey: "landing.launch.title",
    excerptKey: "landing.launch.excerpt",
    date: "2026-07-16",
    readingTimeKey: "landing.news.readingTime",
  },
];
